import { CitationSource } from 'types/chat-message'

type ImageCitationProps = {
  source?: CitationSource
}

/** Inline image citation ([img:N]): the image when ready, a skeleton while loading. */
export const ImageCitation = ({ source }: ImageCitationProps) => {
  if (!source?.imageUrl) {
    return <span className="my-2 block h-[160px] max-w-[280px] animate-pulse overflow-hidden rounded-lg bg-muted" />
  }

  return (
    <a
      href={source.imageUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="my-2 block max-w-[280px] overflow-hidden rounded-lg border border-border shadow-xs transition-shadow hover:shadow-md"
    >
      <img src={source.imageUrl} alt={source.name} className="h-auto w-full object-contain" loading="lazy" />
      {source.name && source.name !== 'Unknown' && (
        <span className="flex items-center gap-1.5 border-t border-border bg-muted/50 px-2 py-1">
          <span className="truncate text-xs text-muted-foreground">{source.name}</span>
        </span>
      )}
    </a>
  )
}
